module.exports = __webpack_public_path__ + "static/media/photo119.926abfd4.jpg";